import type { Ref } from 'react'
import { Button as MantineButton, type ButtonProps as MantineButtonProps } from '@mantine/core'

export interface ButtonProps extends MantineButtonProps {
  label: string
  onClick: () => void
  // Passed through to the button element, for callers that need to move focus to it.
  ref?: Ref<HTMLButtonElement>
}

export function Button({ label, onClick, ...rest }: Readonly<ButtonProps>) {
  return (
    <MantineButton {...rest} onClick={onClick}>
      {label}
    </MantineButton>
  )
}
